import React, { useState } from 'react';

import { FiTrash2, FiAlertCircle } from 'react-icons/fi';

import { Button2 } from '@c';

import styles from './style.module.css';

const Images = React.memo(
    ({
        value = [],
        onChange = () => {},
        imageClassName = '',
        iconClassName = '',
        buttonClassName = '',
        buttonsClassName = '',
        imagesClassName = '',
    }) => {
        const [isAddImage, setIsAddImage] = useState(false);
        const [link, setLink] = useState('');
        const [errored, setErrored] = useState({});

        return (
            <>
                <div className={imagesClassName}>
                    {value.map((el, i) => (
                        <div key={i} className={imageClassName}>
                            <FiTrash2
                                className={iconClassName}
                                size={25}
                                color={'red'}
                                onClick={() =>
                                    onChange(
                                        value.filter((_, idx) => idx !== i)
                                    )
                                }
                            />
                            {errored[el] ? (
                                <div className={styles.error}>
                                    <FiAlertCircle
                                        className={styles.error__icon}
                                        size={28}
                                    />
                                    <p className={styles.error__text}>
                                        Не удалось загрузить изображение по
                                        URL:{' '}
                                        <span className={styles.error__url}>
                                            {el}
                                        </span>
                                    </p>
                                </div>
                            ) : (
                                <img
                                    src={el}
                                    alt="Изображение"
                                    onError={() =>
                                        setErrored((prev) => ({
                                            ...prev,
                                            [el]: true,
                                        }))
                                    }
                                />
                            )}
                        </div>
                    ))}
                </div>
                {isAddImage ? (
                    <>
                        <input
                            value={link}
                            onChange={({ target: { value } }) => setLink(value)}
                            placeholder="Ссылка на изображение"
                        />
                        <div className={buttonsClassName}>
                            <Button2
                                title="Добавить"
                                className={buttonClassName}
                                onClick={() => {
                                    onChange([...value, link]);
                                    setLink('');
                                    setIsAddImage(false);
                                }}
                            />
                            <Button2
                                title="Отмена"
                                className={buttonClassName}
                                onClick={() => setIsAddImage(false)}
                            />
                        </div>
                    </>
                ) : (
                    <Button2
                        title="Добавить изображение"
                        className={buttonClassName}
                        onClick={() => setIsAddImage(true)}
                    />
                )}
            </>
        );
    }
);

export { Images };
